import type { CSSProperties } from 'react'
import { TooltipWrapper } from 'app/components/ui/tooltip-wrapper'
import { formatDate } from 'app/date.utils'
import type { SyncJobProgress } from 'app/types/integrations'

const numberFormat = new Intl.NumberFormat(`en-US`)
const TOOLTIP_DELAY_MS = 300

export function SyncProgressBar({ job }: { job: SyncJobProgress }) {
  const { percentComplete, completed, totalTasks, createdAt } = job

  return (
    <TooltipWrapper
      className="block w-full"
      delayDuration={TOOLTIP_DELAY_MS}
      message={`${numberFormat.format(completed)} of ${numberFormat.format(totalTasks)} tasks done. Started ${formatDate({ value: createdAt, useLocalUtc: true })}.`}
    >
      <span className="flex flex-col gap-1">
        <span className="flex items-baseline justify-between gap-2 text-ui-xs">
          <span className="font-medium text-default">Syncing</span>
          <span className="font-medium tabular-nums text-strong">{percentComplete}%</span>
        </span>
        <span
          role="progressbar"
          aria-valuenow={percentComplete}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Sync ${percentComplete}% complete`}
          className="block h-1.5 w-full overflow-hidden rounded-full bg-surface-muted"
          style={{ '--sync-progress': `${percentComplete}%` } as CSSProperties}
        >
          <span className="block h-full w-(--sync-progress) rounded-full bg-primary-600 transition-all duration-300 ease-out" />
        </span>
      </span>
    </TooltipWrapper>
  )
}
